import FormattedMessage from 'I18n/components/FormattedMessage';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const ProductHighlightError = () => /*#__PURE__*/_jsx(ErrorMessage, {
  type: "badRequest",
  "data-test-id": "product-highlight-card-content-error",
  title: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "error.title"
  }),
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "error.errorMessage"
  })
});